import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import PassengerService from "../../../../services/reservations/PassengerService";

export const REQUEST_FETCH_CRUISES_BY_PASSENGER =
  "REQUEST_FETCH_CRUISES_BY_PASSENGER";
export const FETCH_CRUISES_BY_PASSENGER_SUCCESS =
  "FETCH_CRUISES_BY_PASSENGER_SUCCESS";
export const FETCH_CRUISES_BY_PASSENGER_ERROR =
  "FETCH_CRUISES_BY_PASSENGER_ERROR";
export const INITIAL_STATE_CRUISE_BY_PASSENGER =
  "INITIAL_STATE_CRUISE_BY_PASSENGER";

function requestFetchCruisesByPassenger() {
  return {
    type: REQUEST_FETCH_CRUISES_BY_PASSENGER,
  };
}

function fetchCruisesByPassengerSuccess(json) {
  return {
    type: FETCH_CRUISES_BY_PASSENGER_SUCCESS,
    cruises: json.data,
  };
}

function fetchCruisesByPassengerError(json) {
  return {
    type: FETCH_CRUISES_BY_PASSENGER_ERROR,
    error: json.data,
  };
}

export function initialStateCruiseByPassenger() {
  return {
    type: INITIAL_STATE_CRUISE_BY_PASSENGER,
  };
}

export function fetchCruisesByPassenger(passenger_id) {
  return (dispatch) => {
    dispatch(requestFetchCruisesByPassenger());
    return PassengerService.getCruisesByPassenger(passenger_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchCruisesByPassengerSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchCruisesByPassenger(passenger_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchCruisesByPassengerError(json.data));
      }
    });
  };
}
